const info = {
  ZH: {
    //中文翻译
    requireDirectory: "请选择一个目录",
    requireDeleteDirectory: "请选择一个要删除的目录",
    requireEditDirectory: "请选择一个要编辑的目录",
    confirmDelete: "确认删除此文件夹及文件夹所有信息？",
  },
  EN: {
    //英文翻译
    requireDirectory: "Please select a directory",
    requireDeleteDirectory:"Please select a directory to delete",
    requireEditDirectory: "Please select a directory to edit",
    confirmDelete: "Are you sure to delete this folder and remove all the data in it?",
  },
};
export default info; //需要暴露出去
